export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-900">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full mb-5">
                <i className="ri-smartphone-line text-accent-400 text-sm"></i>
                <span className="text-accent-300 text-xs font-medium">随时随地 · 超清观影</span>
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
                麻花影院 APP
              </h2>
              <p className="text-white/65 text-sm md:text-base leading-relaxed max-w-lg mb-8">
                下载麻花影院专属APP，畅享4K超清画质观影体验。支持离线缓存、观影记录云端同步、
                个性化推荐等专属功能。无论在地铁、咖啡厅还是家中，随时随地打开手机就能享受电影院级的蓝光画质。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mb-8">
                <div className="flex items-center gap-2 bg-white/10 rounded-lg px-4 py-2.5">
                  <i className="ri-apple-line text-white text-xl"></i>
                  <div className="text-left">
                    <div className="text-white text-xs font-medium">App Store</div>
                    <div className="text-white/40 text-[10px]">iOS 下载</div>
                  </div>
                </div>
                <div className="flex items-center gap-2 bg-white/10 rounded-lg px-4 py-2.5">
                  <i className="ri-android-line text-white text-xl"></i>
                  <div className="text-left">
                    <div className="text-white text-xs font-medium">Google Play</div>
                    <div className="text-white/40 text-[10px]">Android 下载</div>
                  </div>
                </div>
                <div className="flex items-center gap-2 bg-white/10 rounded-lg px-4 py-2.5">
                  <i className="ri-qr-code-line text-white text-xl"></i>
                  <div className="text-left">
                    <div className="text-white text-xs font-medium">扫码下载</div>
                    <div className="text-white/40 text-[10px]">手机扫码安装</div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#features"
                  className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-950 font-medium px-6 py-3 rounded-lg transition-colors text-sm whitespace-nowrap"
                >
                  <i className="ri-download-line"></i>
                  立即下载
                </a>
                <a
                  href="#about"
                  className="inline-flex items-center gap-2 border border-white/20 text-white hover:bg-white/10 px-6 py-3 rounded-lg transition-colors text-sm whitespace-nowrap"
                >
                  <i className="ri-information-line"></i>
                  了解更多
                </a>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="relative">
                <div className="w-64 h-[450px] rounded-3xl overflow-hidden border-4 border-white/20 shadow-2xl">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20showing%20movie%20streaming%20app%20interface%20with%20cinematic%20film%20posters%2C%20dark%20mode%20UI%20with%20warm%20red%20and%20gold%20accents%2C%20clean%20modern%20mobile%20app%20design%2C%20movie%20thumbnails%20grid%20layout%2C%20professional%20app%20screen%20mockup%2C%20minimalist%20flat%20design&width=600&height=1200&seq=mahua-app-mockup&orientation=portrait"
                    alt="麻花影院APP界面展示"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute -top-4 -right-4 w-16 h-16 bg-accent-500 rounded-2xl flex items-center justify-center shadow-lg rotate-12">
                  <span className="text-background-950 font-heading font-bold text-xs">4K</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}